export default "__VITE_ASSET__CEFeDS53__"